import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Button,
  DialogOpenChangeEvent,
} from '@fluentui/react-components'
import { useState } from 'react'

type ConfirmDialogProps = {
  trigger?: React.ReactElement
  title: string
  content: React.ReactNode
  cancelText?: string
  confirmText?: string
  onCancel?: () => void
  onConfirm?: () => void
  onClose?: () => void
  isOpen?: boolean
  setIsOpen?: (open: boolean) => void
}

export function ConfirmDialog({
  trigger,
  title,
  content,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  onCancel,
  onConfirm,
  onClose,
  isOpen: isOpenProp,
  setIsOpen: setIsOpenProp,
}: ConfirmDialogProps) {
  const [isOpen, setIsOpen] = useState(false)

  function handleOpenChange(_event: DialogOpenChangeEvent, data: { open: boolean }) {
    if (!data.open) {
      onClose?.()
    }
    if (setIsOpenProp) {
      setIsOpenProp(data.open)
    } else {
      setIsOpen(data.open)
    }
  }

  return (
    <Dialog open={isOpenProp === undefined ? isOpen : isOpenProp} onOpenChange={handleOpenChange}>
      <DialogTrigger disableButtonEnhancement>{trigger}</DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>{content}</DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary" onClick={onCancel}>
                {cancelText}
              </Button>
            </DialogTrigger>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="primary" onClick={onConfirm}>
                {confirmText}
              </Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  )
}
